import { config } from '@abyss/ui/tools/config';
import { useQuery } from '../../tools/useQuery';

const parseResult = result => {
  const initialState = [];

  if (result && result.tins) {
    const permissions = [];

    (result.tins || []).forEach(record => {
      let privileges = [];
      if (record.permission) {
        privileges = record.permission
          .map(item => {
            if (item && item.legacyPrivileges) {
              return item.legacyPrivileges;
            }
            return [];
          })
          .flat()
          .filter(e => {
            return e !== null;
          });
      }
      const obj = {
        id: result.id,
        tin: record.tin,
        tinType: record.tinTypeCode,
        allPermission: record.allPermission,
        privileges,
      };

      permissions.push(obj);
    });

    return permissions;
  }

  return initialState;
};

export const useProviderPrivileges = options => {
  const url = `${config('DS_STARGATE_API_URL')}/tin/v1.0`;

  const [queryResult, queryAction] = useQuery(url, {
    ...options,
    onCompleted: result => {
      options.onCompleted(parseResult(result.body));
    },
  });

  const parsedResult = {
    ...queryResult,
    data: parseResult(queryResult.data),
  };

  return [parsedResult, queryAction];
};
